import script from "./MaintenancePage.vue?vue&type=script&setup=true&lang=js"
export * from "./MaintenancePage.vue?vue&type=script&setup=true&lang=js"

import "./MaintenancePage.vue?vue&type=style&index=0&id=083e439d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-083e439d"]])

export default __exports__